import React from 'react';
import { connect } from 'react-redux';
import { Filter, UserProductGroup, UserProductGroupErrorResponse } from '~/Api/User/ProductGroup';
import { handleError } from '~/ErrorHandler';
import { flashErrorMessage, flashSuccessMessage } from '~/FlashMessage';
import flashMessageStyles from '~/FlashMessage/styles.less';
import { logGoogleTagManagerGroupProductsAdd } from '~/GoogleTagManager';
import { addSelectionToGroup, Selection } from '~/GroupProduct';
import { selectCardinalPlural } from '~/libs/Intl';
import { fetchGroups } from '~/ProductGroup';
import { LinkProvider } from '~/ProductGroupDetail';
import { Link } from '~/UI/Button';
import GroupPanel from './GroupPanel';

import type { AnyAction } from 'redux';
import type { ThunkDispatch } from '~/Store';

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	props: {
		selectedProductsCount: number;
		onAddProductsToGroup: (group: UserProductGroup, selection: Selection) => void;
	}
): {
	onAddProductsToGroup: (group: UserProductGroup, selection: Selection) => void;
} {
	return {
		onAddProductsToGroup: (group: UserProductGroup, selection: Selection) => {
			dispatch(addSelectionToGroup(group, selection))
				.then(() => {
					props.onAddProductsToGroup(group, selection);
					dispatch(
						flashSuccessMessage(
							<span>
								{props.selectedProductsCount} {selectCardinalPlural(props.selectedProductsCount, ['drug', 'drugs'])}{' '}
								added to list{' '}
								<LinkProvider group={group}>
									{(link) => (
										<Link styles={flashMessageStyles} title={group.name} to={link}>
											{group.name}
										</Link>
									)}
								</LinkProvider>
							</span>
						)
					);

					logGoogleTagManagerGroupProductsAdd(
						group.id,
						selection.type === 'products' ? Array.from(selection.products) : null,
						selection.query.filterParameters
					);
				})
				.catch((response) => {
					if (!(response instanceof UserProductGroupErrorResponse)) {
						dispatch(handleError(response));
						return;
					}
					if (response.handleProductGroupNotFound()) {
						dispatch(fetchGroups(new Filter(group.parent?.id || null, null), 1));
					}
					if (response.handleProductGroupAddItemsLimit()) {
						const error = response.findAddItemsLimitError();
						dispatch(
							flashErrorMessage(
								`Cannot add more than ${error?.limit || '~2000'} products at once, try add less products in more steps`
							)
						);
					}
					dispatch(handleError(response));
				})
				.catch((response) => dispatch(handleError(response)));
		},
	};
}

export default connect(null, mapDispatchToProps)(GroupPanel);
